import React from "react";
import {
  Box,
  TextField,
  Grid,
  FormControl,
  FormControlLabel,
  Checkbox,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import { StepContent } from "../../styles/StyledComponents";
import { RELAZIONI_BENEFICIARIO } from "../../constants";

const Step3Beneficiario = ({ formData, handleInputChange, onReset }) => {
  return (
    <StepContent>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="outlined"
          onClick={onReset}
          size="small"
        >
          Reset Campi
        </Button>
      </Box>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #ff6f00, #ff9800)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            mb: 2,
          }}
        >
          <FavoriteRoundedIcon sx={{ fontSize: 40, color: "white" }} />
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#fff8e1"
              : "rgba(255, 152, 0, 0.1)",
          border: (theme) =>
            `2px solid ${
              theme.palette.mode === "light" ? "#ffb74d" : "#ff9800"
            }`,
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.hasBeneficiario}
              onChange={handleInputChange("hasBeneficiario")}
              sx={{
                color: "#ff9800",
                "&.Mui-checked": { color: "#ff6f00" },
              }}
            />
          }
          label={
            <Box>
              <Typography variant="body1" fontWeight={600}>
                Desidero nominare un beneficiario
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Il beneficiario riceverà il capitale assicurato in caso di
                evento coperto dalla polizza
              </Typography>
            </Box>
          }
        />
      </Box>

      {formData.hasBeneficiario && (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="Nome Beneficiario"
              value={formData.nomeBeneficiario}
              onChange={handleInputChange("nomeBeneficiario")}
              placeholder="Nome"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="Cognome"
              value={formData.cognomeBeneficiario}
              onChange={handleInputChange("cognomeBeneficiario")}
              placeholder="Cognome"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth required size="small">
              <InputLabel>Relazione</InputLabel>
              <Select
                value={formData.relazioneBeneficiario}
                onChange={handleInputChange("relazioneBeneficiario")}
                label="Relazione"
              >
                <MenuItem value="">
                  <em>Seleziona la relazione</em>
                </MenuItem>
                {RELAZIONI_BENEFICIARIO.map((rel) => (
                  <MenuItem key={rel.value} value={rel.value}>
                    {rel.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="email"
              label="Email (opzionale)"
              value={formData.emailBeneficiario}
              onChange={handleInputChange("emailBeneficiario")}
              placeholder="email@esempio.com"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Telefono (opzionale)"
              value={formData.telefonoBeneficiario}
              onChange={handleInputChange("telefonoBeneficiario")}
              placeholder="+39 3123456789"
            />
          </Grid>
        </Grid>
      )}
    </StepContent>
  );
};

export default Step3Beneficiario;
